<section class="overlay-panel-container news-layout">
  @if (openPanel) {
  <div class="overlay-panel-content" [@slideInRight]>
    <header class="d-flex align-items-center p-2">
      <div>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon><span class="font-weight-bold user-manual" style="font-size: 20px;
                    cursor: none;">{{ 'ime.user.manual' | translate}}
          </span>
        </button>
        <div class="ml-3 d-flex align-items-center gap-3">
          <button mat-icon-button (click)="downloadUserManual()">
            <mat-icon class="text-primary" style="font-size: 20px;">download</mat-icon><span class="text-primary"
              style="cursor: pointer;">{{
              'download' | translate
              }}
            </span>
          </button>
          <span class="d-inline-block" style="font-size: x-small;">{{'ime.usermanual.main.title.content.label' |
            translate}}</span>
        </div>
      </div>
    </header>
    <mat-divider></mat-divider>
    <main class="d-flex flex-column overflow-auto h-100 w-100 pb-3">
      <div class="news-container">
        <div class="ml-2 mt-2 d-flex justify-content-between align-items-center">
          <h6 class="text-primary font-weight-bold">{{'ime.user.manual.sub.title' | translate}}</h6>
        </div>
        <div #pdfViewerContainer></div>
      </div>
    </main>
  </div>
  }
</section>